import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { DropdownModule } from '../common/dropdown/dropdown.module';
import { RtUICoreOverlayModule } from '../core/overlay/overlay.module';
import { InputModule } from '../forms/input/input.module';
import { InputWithSelectDropdownComponent } from './input-with-select-dropdown/input-with-select-dropdown.component';
import { InputWithSelectComponent } from './input-with-select.component';

@NgModule({
  imports: [CommonModule, DropdownModule, RtUICoreOverlayModule, ReactiveFormsModule, InputModule],
  declarations: [InputWithSelectComponent, InputWithSelectDropdownComponent],
  exports: [InputWithSelectComponent, InputWithSelectDropdownComponent],
})
export class RtInputWithSelectModule {}
export {
  InputSelectDropdownOption,
  InputWithSelectDropdownComponent,
} from './input-with-select-dropdown/input-with-select-dropdown.component';
export { InputWithSelectComponent } from './input-with-select.component';
